import React, { useEffect, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import PropTypes from "prop-types";
import fp from "lodash/fp";
import theme from "@styles/theme";
import { Grid } from "@mzc-pdc/ui";

const WidgetWrap = ({ id, onMove, fullWidth, children, blockDrag, type }) => {
    const [{ isDragging }, connectDrag] = useDrag({
        item: { id, type: `WIDGET` },
        collect: (monitor) => {
            return {
                isDragging: monitor.isDragging(),
            };
        },
    });
    const [, connectDrop] = useDrop({
        accept: `WIDGET`,
        hover(hoveredOverItem) {
            const hoverItemId = fp.get(`id`, hoveredOverItem);
            !fp.isEqual(hoverItemId, id) && onMove(hoverItemId, id);
        },
    });
    const ref = useRef(null);

    useEffect(() => {
        if (blockDrag) return;
        connectDrag(ref);
        connectDrop(ref);
    }, [ref, fullWidth]);

    return (
        <Grid
            ref={ref}
            container
            className={`widget ${!fullWidth && isDragging ? `dragging` : ``} ${fullWidth ? `full-width` : ``} ${
                type === "notice" ? "widget-notice" : ""
            }`}
            flexDirection={"column"}
            style={{
                borderRadius: "6px",
                border: `1px solid ${theme.palette.greySecondary[100]}`,
                boxShadow: `0px 2px 4px 0px rgba(0, 0, 0, 0.12)`,
            }}
        >
            {children}
        </Grid>
    );
};

WidgetWrap.propTypes = {
    id: PropTypes.string,
    onMove: PropTypes.func,
    children: PropTypes.node,
};

export default WidgetWrap;
